import React, { forwardRef, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Basic input radio with label to group with other Radios.
 */
const Radio = forwardRef((props, ref) => {
  const {
    children, disabled, name, value, inline, checked, onChange, className,
  } = props;

  const [checkedState, setCheckedState] = useState(checked);

  const handleChange = (e) => {
    onChange(e);
  };

  useImperativeHandle(ref, () => ({
    updateValue(newValue) {
      setCheckedState(newValue);
    },
  }));

  return (
    <div className={`form-check ${inline ? 'form-check-inline' : ''} ${className}`}>
      <input disabled={disabled} className="form-check-input" id={`rd-${children}`} name={name} type="radio" onChange={handleChange} value={value} checked={checkedState} />
      <label className="form-check-label" htmlFor={`rd-${children}`}>{children}</label>
    </div>
  );
});

Radio.propTypes = {
  /**
   * Label text
   */
  children: PropTypes.string,
  /**
   * Value to send when the radio is clicked
   */
  value: PropTypes.string,
  /**
   * Print the radio inline or block
   */
  inline: PropTypes.bool,
  /**
   * Name of the radio group
   */
  name: PropTypes.string.isRequired,
  /**
   * The checkbox is checked
   */
  checked: PropTypes.bool,
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * Custom css class
   */
  className: PropTypes.string,
};

Radio.defaultProps = {
  children: '',
  inline: false,
  value: '',
  checked: false,
  className: '',
  onChange: () => {},
};

export default Radio;
